import { render, staticRenderFns } from "./store_set_vod.vue?vue&type=template&id=3793d3b6&scoped=true"
import script from "./store_set_vod.vue?vue&type=script&lang=js"
export * from "./store_set_vod.vue?vue&type=script&lang=js"
import style0 from "./store_set_vod.vue?vue&type=style&index=0&id=3793d3b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3793d3b6",
  null
  
)

export default component.exports